import React, {Component} from 'react';
import CreateEditGroup from "./CreateEditGroupView";
import {ValueTypeService} from "../../../../service/maintenance/valueType/ValueTypeService";
import Typography from "@material-ui/core/Typography";
import {Builder} from "../../../../utils/lists/ListProcessor";
import {VALUE_TYPES_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";

export default class CreateEditGroupContainer extends Component {
    constructor(props) {
        super(props);

        this.valueTypeService = new ValueTypeService();

        this.getValueTypesWithoutGroup = this.getValueTypesWithoutGroup.bind(this);
        this.onChangePickList = this.onChangePickList.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.createGroup = this.createGroup.bind(this);
        this.getIds = this.getIds.bind(this);
        this.returnPage = this.returnPage.bind(this);
        this.getValueTypeInGroup = this.getValueTypeInGroup.bind(this);
        this.editGroup = this.editGroup.bind(this);

        this.state = {
            isLoading: true,
            groupName: '',
            sourceProcess: [],
            targetProcess: [],
            group: props.location.state.group !== undefined ? props.location.state.group : '',
        };

        this.getValueTypesWithoutGroup();

        if (this.state.group !== '') {
            this.getValueTypeInGroup();
        }
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    processTemplate(process) {
        return (
            <div className="p-clearfix">
                <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}>
                    {process.nombre}
                </Typography>
            </div>
        );
    }

    onChangePickList(event) {
        this.setState({
            sourceProcess: event.source,
            targetProcess: event.target
        });
    }

    getValueTypesWithoutGroup() {
        this.loading(true);
        this.valueTypeService.getValueTypesWithoutGroup().then(response => {
            response.payload.forEach(function (v) {
                v.groupId = v.grupo.id;
                v.groupName = v.grupo.nombre;
                delete v.grupo;
            });

            let builder = new Builder();
            builder.groupList(response.payload, 'groupName');

            this.setState({
                sourceProcess: response.payload,
            });
            this.loading(false);
        });
    }

    onChangeText(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    getIds() {
        let ids = '';
        this.state.targetProcess.map(item => {
            ids += item.id + '|';
            return '';
        });
        ids = ids.substring(0, ids.length - 1);
        return ids;
    }

    createGroup() {
        this.loading(true);
        this.valueTypeService.createGroup(this.state.groupName, this.getIds())
            .then(res => {
                if (res.error && res.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: res.error
                    });
                }else{
                    let messageObj = {};
                    messageObj['severity'] = 'success';
                    messageObj['sumary'] = 'Éxito';
                    messageObj['detail'] = (res.message === 'Success' || res.message === '')?
                        'El grupo se ha agregado con éxito' : res.message;
                    this.returnPage(messageObj);
                }
                this.loading(false);
            });
    }

    returnPage(message) {
        this.props.history.push({
            pathname: VALUE_TYPES_ROUTE,
            message: message,
            state: {},
        });
    }

    getValueTypeInGroup() {
        this.loading(true);

        this.valueTypeService.getValueTypeInGroup(this.state.group.groupId).then(response => {
            response.payload.forEach(function (v) {
                v.groupId = v.grupo.id;
                v.groupName = v.grupo.nombre;
                delete v.grupo;
            });

            let builder = new Builder();
            builder.groupList(response.payload, 'groupName');

            this.setState({
                targetProcess: response.payload,
            });
            this.loading(false);
        });
    }

    editGroup() {
        this.loading(true);
        this.valueTypeService.editGroup(this.state.group.groupId, this.state.group.groupName, this.getIds())
            .then(res => {
                if (res.error && res.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: res.error
                    });
                }else{
                    let messageObj = {};
                    messageObj['severity'] = 'success';
                    messageObj['sumary'] = 'Éxito';
                    messageObj['detail'] = (res.message === 'Success' || res.message === '')?
                        'El grupo se ha actualizado con éxito' : res.message;
                    this.returnPage(messageObj);
                }
                this.loading(false);
            });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return (
            <CreateEditGroup
                isLoading={this.state.isLoading}
                isUpdate={this.state.isUpdate}
                processTemplate={this.processTemplate}
                onChangePickList={this.onChangePickList}
                sourceProcess={this.state.sourceProcess}
                targetProcess={this.state.targetProcess}
                groupName={this.state.groupName}
                onChangeText={this.onChangeText}
                createGroup={this.createGroup}
                returnPage={this.returnPage}
                group={this.state.group}
                editGroup={this.editGroup}
                messagesGrowl={messagesGrowl}
            />
        );
    }
}